import React from "react";
import { titles } from "constants/titles";
import CustomButton from "components/widgets/custom-button/CustomButton";
import { convertInRequiredTimeZone } from "utility";
import { IconMapPin } from "assets/SVGs/SVGs";

const CaregiverTrackingCard = ({
  deviceLocation,
  customSchemaForUI = ()=>{},
  onCaregavireTracking,
  onLocationHistory,
  selectedDeviceDetails,
  selectedMedicalUser,
  currentTimeZone,
}) => {
  // Check if location is available (latitude and longitude must be non-zero, non-null, and valid numbers)
  const hasLocation =
    deviceLocation?.latitude !== null &&
    deviceLocation?.latitude !== undefined &&
    deviceLocation?.longitude !== null &&
    deviceLocation?.longitude !== undefined &&
    deviceLocation?.latitude !== 0 &&
    deviceLocation?.longitude !== 0 &&
    !isNaN(deviceLocation?.latitude) &&
    !isNaN(deviceLocation?.longitude);

  return (
    <div className="dp_caregiver_card">
      <h3 className="dp_caregiver_title">{titles?.caregiver_tracking}</h3>

      {/* Only show map information when location is available - matches RN app */}
      {hasLocation &&
        (customSchemaForUI()?.locationTimeStamp) && (
          <p className="dp_map_info">
            {`${titles?.map_information} ${convertInRequiredTimeZone(
              customSchemaForUI()?.locationTimeStamp ,
              selectedMedicalUser?.timezone,
              currentTimeZone
            )}`}
          </p>
        )}

      <div
        className={
          hasLocation ? "dp_map_container" : "dp_map_container_no_data"
        }
      >
        {!hasLocation ? (
          <div className="dp_map_not_available_container">
            <IconMapPin width="32" height="32" />
            <p className="dp_map_not_available_title">
              {titles?.map_not_available}
            </p>
            <p className="dp_map_not_available_subtitle">
              {titles?.cell_coverage_required}
            </p>
          </div>
        ) : (
          <iframe
            src={`https://maps.google.com/maps?q=${deviceLocation?.latitude},${deviceLocation?.longitude}&z=15&output=embed`}
            width="100%"
            height="100%"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="gmap"
            className="dp_map_iframe"
          />
        )}
      </div>

      {/* Only show buttons when location is available - matches RN app */}
      {hasLocation && (
        <div className="dp_caregiver_buttons">
          <CustomButton
            text={titles?.see_map}
            width="100%"
            className="dp_see_map_button"
            onClick={() => onCaregavireTracking()}
          />

          {selectedDeviceDetails?.is_show_location_history ? (
            <CustomButton
              text={titles?.location_history}
              width="100%"
              className="dp_location_history_button"
              onClick={() => onLocationHistory()}
            />
          ) : null}
        </div>
      )}
    </div>
  );
};

export default CaregiverTrackingCard;
